import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { trackPageView, trackEvent, setUser } from '../lib/analytics';
import { useAuth } from './use-auth';

/**
 * Hook to set up automatic page view tracking with Google Analytics
 */
export const usePageViewTracking = () => {
  const [location] = useLocation();
  const { user } = useAuth();

  // Track page views when location changes
  useEffect(() => {
    // Send page view to Google Analytics
    trackPageView(location);
  }, [location]);

  // Set user ID for tracking if user is logged in
  useEffect(() => {
    if (user?.id) {
      // Set user ID for cross-device tracking
      setUser(user.id.toString());
    }
  }, [user?.id]);

  return null;
};

/**
 * Utility function to track specific events
 * @param category Event category
 * @param action Event action
 * @param label Optional event label
 * @param value Optional event value (must be a number)
 */
export const logEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
) => {
  trackEvent(category, action, label, value);
};